import { gql } from "@apollo/client";

export const CREATE_CLIENT = gql`
  mutation createClient($input: createClientInput) {
    createClient(input: $input) {
      clientId
    }
  }
`;




export const UPDATE_CLIENT = gql`
  mutation updateClient($input: updateClientInput) {
    updateClient(input: $input)
  }
`;
export const CLIENTS_BY_ORG = gql`
  query ClientsByOrg($orgId: Int) {
    clientsByOrg(orgId: $orgId) {
      clientId
      name
      industry
      email
      primaryContact
      secondaryContact
      noOfEmployees
      services
      status
      location
      orgId
      primaryName
      secondaryName
      linkedIn
      website
      PAN
      GST
      TAN
      TIN
      AlternateEmail
      subData {
        vendorName
        primaryName
      }
      industryDetails {
        name
      }
      logo
      isBoolean
    }
  }
`;

export const CREATE_VENDOR = gql`
  mutation createVendor($input: createVendorInput) {
    createVendor(input: $input) {
      vendorId
    }
  }
`;
export const UPDATE_VENDOR = gql`
  mutation updateVendor($input: updateVendorInput) {
    updateVendor(input: $input)
  }
`;
export const VENDORS_BY_ORG = gql`
  query vendorsByOrg($orgId: Int) {
    vendorsByOrg(orgId: $orgId) {
      vendorId
      name
      industry
      email
      primaryContact
      secondaryContact
      noOfEmployees
      services
      status
      location
      orgId
      primaryName
      secondaryName
      linkedIn
      website
      PAN
      GST
      TAN
      TIN
      AlternateEmail
      industryDetails {
        name
      }
      logo
      isBoolean
    }
  }
`;







export const UPDATE_SUB_VENDOR = gql`
  mutation updateSubVendor($input: updateSubVendorInput) {
    updateSubVendor(input: $input)
  }
`;
export const CREATE_SUB_VENDOR = gql`
  mutation createSubVendor($input: createSubVendorInput) {
    createSubVendor(input: $input) {
      subvendorId
    }
  }
`;
